import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function PortalModuleToggle({ moduleKey, title, description }) {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let active = true;
    api
      .get("/admin/portal-modules")
      .then(({ data }) => {
        if (active) setEnabled(Boolean(data?.[moduleKey]));
      })
      .catch((error) => {
        if (active) toast.error(formatApiError(error));
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [moduleKey]);

  const toggle = async () => {
    if (loading || saving) return;
    const next = !enabled;
    setSaving(true);
    try {
      const { data } = await api.patch("/admin/portal-modules", {
        [moduleKey]: next,
      });
      setEnabled(Boolean(data?.[moduleKey]));
      toast.success(
        next ? `${title} kullanıcı panelinde açıldı` : `${title} kullanıcı panelinde kapatıldı`,
      );
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section
      className="mb-6 border border-pleiades-border bg-white p-5"
      aria-labelledby={`${moduleKey}-title`}
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="max-w-2xl">
          <div className="text-[10px] uppercase tracking-[.14em] text-pleiades-muted">
            Danışan paneli görünürlüğü
          </div>
          <h2 id={`${moduleKey}-title`} className="mt-1 text-[14px] font-semibold">
            {title}
          </h2>
          <p className="mt-1 text-[12px] leading-relaxed text-pleiades-slate">{description}</p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          disabled={loading || saving}
          onClick={toggle}
          className={`min-h-11 min-w-32 border px-4 text-[12px] font-medium disabled:cursor-wait disabled:opacity-60 ${
            enabled
              ? "border-emerald-600 bg-emerald-50 text-emerald-800"
              : "border-pleiades-border bg-pleiades-ivory text-pleiades-slate"
          }`}
        >
          {loading ? "Yükleniyor…" : saving ? "Kaydediliyor…" : enabled ? "Aktif" : "Pasif"}
        </button>
      </div>
    </section>
  );
}
